import { RadioGroupWUT } from '@wix/form-fields/wut';

export default RadioGroupWUT;
